import React from "react";
import {
  Menu,
  List,
  ListItem,
  ListItemText,
  Typography
} from "@material-ui/core";
import useStyles from "../../styles/commonNotifyStyle";
import moment from "dayjs";
import NotificationDetailDialog, {
  notificationColorMap
} from "./AppNotificationDetailDialog";
import { useTranslation } from "../../langs/useTranslation";

const NotificationList = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    anchorEl,
    open,
    onClose,
    notiItems,
    notiDetailDialogOpen,
    handleNotificationDialogOpen,
    handleNotificationDialogClose,
    currentNotiItem,
    hasConfirmBtn
  } = props;

  const updateNotification = notiItem => {
    handleNotificationDialogOpen(notiItem);
  };

  const tagTextMap = {
    "Alarm Notification": t({ defaultMessage: "报警通知" }),
    "Platform Notification": t({ defaultMessage: "平台公告" })
  };

  const renderTag = info => {
    const colorStyle =
      notificationColorMap[info.type] ||
      notificationColorMap["Platform Notification"];
    return (
      <span className={classes.notiMainTag} style={colorStyle}>
        {tagTextMap[info.type] || tagTextMap["Platform Notification"]}
      </span>
    );
  };

  return (
    <>
      {open && (
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          keepMounted
          className={`${classes.menuList} ${classes.notificationList}`}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          open={open}
          onClose={onClose}
        >
          <div
            style={{ padding: "10px 15px 0", fontSize: 16, fontWeight: 500 }}
          >
            {t({ defaultMessage: "消息通知" })}
          </div>
          <List>
            {notiItems.length > 0 ? (
              notiItems.map(notiItem => {
                const info = notiItem.json || {};

                return (
                  <ListItem
                    alignItems="flex-start"
                    button
                    onClick={() => updateNotification(notiItem)}
                    key={notiItem.id}
                    id={notiItem.id}
                    style={{ margin: 15 }}
                  >
                    <ListItemText className={classes.notiListText}>
                      <Typography
                        variant="body1"
                        className={classes.notiMainText}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: 500
                          }}
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html: info.title
                            }}
                          />
                          {notiItem.readAt < 0 && (
                            <div
                              style={{
                                display: "inline-block",
                                marginLeft: 10,
                                height: 6,
                                width: 6,
                                minWidth: 6,
                                minHeight: 6,
                                backgroundColor: "red",
                                borderRadius: "50%"
                              }}
                            />
                          )}
                        </div>

                        {renderTag(info)}
                      </Typography>
                      <Typography
                        variant="body2"
                        component="div"
                        className={classes.notiMemos}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: info.message
                          }}
                        />
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between"
                        }}
                      >
                        <Typography variant="caption" color="textSecondary">
                          {notiItem.fromUserName}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {moment(
                            Number(notiItem.createdAt) || undefined
                          ).format("YYYY-MM-DD HH:mm:ss")}
                        </Typography>
                      </div>
                    </ListItemText>
                  </ListItem>
                );
              })
            ) : (
              <Typography
                display="block"
                align="center"
                variant="caption"
                color="textSecondary"
              >
                {t({ defaultMessage: "暂无公告" })}
              </Typography>
            )}
          </List>
        </Menu>
      )}
      <NotificationDetailDialog
        open={notiDetailDialogOpen}
        onClose={handleNotificationDialogClose}
        currentNotiItem={currentNotiItem}
        hasConfirmBtn={hasConfirmBtn}
      />
    </>
  );
};

export default NotificationList;
